import { useState, useEffect } from 'react';
import { FormattedMessage, IntlShape, useIntl } from 'react-intl';
import { SELECT } from 'common/constants';
import { DropdownOption, InputSize } from 'components/Dropdown/types';
import { messages } from './messages';
import { StyledDropdown } from './styled';
import { CashCompanyPropsType } from './types';

export const CashCompanyDropdown = ({
  cashCompanyStores,
  setSelectedCashCompany,
  isLoading,
  defaultOption
}: CashCompanyPropsType): React.JSX.Element => {
  const intl: IntlShape = useIntl();
  const [isCashCompanyError, setIsCashCompanyError] = useState<boolean>(false);
  const [cashCompanyStore, setCashCompanyStore] = useState<DropdownOption>({
    label: intl.formatMessage(messages.cashCompanyDefaultVal),
    value: SELECT
  });

  const handleValidation = (cashInBankAccValue: string) => {
    setIsCashCompanyError(cashInBankAccValue === SELECT);
  };

  const handleCashInBankAccounts = (selectedValue: DropdownOption) => {
    handleValidation(selectedValue.value);
    setCashCompanyStore(selectedValue);
    setSelectedCashCompany(selectedValue);
  };

  useEffect(() => {
    if (defaultOption) {
      setCashCompanyStore(defaultOption);
      setSelectedCashCompany(defaultOption);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultOption?.value]);

  return (
    <StyledDropdown
      isLoading={isLoading}
      inputId="cashCompany"
      dataTestId="cashCompany"
      label={
        <FormattedMessage
          description="Label for Cash Company dropdown"
          defaultMessage="Cash Company"
        />
      }
      placeHolder={
        <FormattedMessage
          description="Place holder message for Cash Company"
          defaultMessage="Select"
        />
      }
      onChange={handleCashInBankAccounts}
      options={cashCompanyStores || []}
      value={cashCompanyStore}
      size={InputSize.STANDARD}
      menuListStyles={{ minWidth: '240px', maxWidth: '500px' }}
      isRequired
      errorMessage={
        <FormattedMessage
          description="Label for select a Cash Company Dropdown"
          defaultMessage="Cash Company is required"
        />
      }
      hasError={isCashCompanyError}
      enableCustomValidation
    />
  );
};
